import {Pipe, PipeTransform} from '@angular/core';
import {capitalCase} from 'change-case';

@Pipe({
    name: 'capitalCase'
})
export class CapitalCasePipe implements PipeTransform {
    transform(value: string | undefined | null): string {
        return capitalCase(value || '');
    }
}
